var map = {
	"./": 69,
	"./en-US": 227,
	"./en-US/": 227,
	"./en-US/Test": 303,
	"./en-US/Test.ts": 303,
	"./en-US/index": 227,
	"./en-US/index.ts": 227,
	"./index": 69,
	"./index.ts": 69,
	"./ko-KR": 228,
	"./ko-KR/": 228,
	"./ko-KR/Test": 304,
	"./ko-KR/Test.ts": 304,
	"./ko-KR/index": 228,
	"./ko-KR/index.ts": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;